import type { SVGProps } from 'react'

/**
 * The two parts of the Edvantage symbol, from the exact geometry in brand-assets/edvantage-symbol.svg (round 5
 * `build.py:33-38`, `tools/geometry.py`). Chevron = forward (something you do next); brace = held (a fact you can rely
 * on). Never tiled, mirrored or cropped as texture, and never a field of small copies.
 */
export const BRACE_VIEWBOX = '34 22.5 31.5 63.6'
export const CHEVRON_VIEWBOX = '75.86 22.52 54.21 64.14'

const BRACE_D =
  'M55.07,23.13c0,11.62-9.44,21.08-21.07,21.08v10.38c17.37,0,31.46-14.08,31.46-31.46h-10.39Z' +
  'M34.01,54.59v10.39c11.62,0,21.07,9.44,21.07,21.06h10.39c0-17.37-14.09-31.46-31.46-31.46Z'
const CHEVRON_POLYGONS = [
  '75.86 22.52 75.86 35.22 130.07 54.51 130.07 41.93 75.86 22.52',
  '130.07 67.1 130.07 54.51 75.86 73.61 75.86 86.66 130.07 67.1',
]

export function BraceShape(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox={BRACE_VIEWBOX} aria-hidden="true" focusable="false" {...props}>
      <path d={BRACE_D} />
    </svg>
  )
}

export function ChevronShape(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox={CHEVRON_VIEWBOX} aria-hidden="true" focusable="false" {...props}>
      {CHEVRON_POLYGONS.map((points) => <polygon key={points} points={points} />)}
    </svg>
  )
}

/** Single-outline chevron and the brace path, for die-cut pieces (face, edge and card thickness). */
export const DIE_CHEVRON_OUTLINE = 'M75.86,22.52L130.07,41.93V67.1L75.86,86.66V73.61L130.07,54.51L75.86,35.22Z'
export const DIE_BRACE_D = BRACE_D
export const DIE_CHEVRON_BOX = { x: 75.86, y: 22.52, w: 54.21, h: 64.14 }
export const DIE_BRACE_BOX = { x: 34.01, y: 23.13, w: 31.45, h: 62.91 }
